// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id='customer-deposit-accounts-check-deposit' class="box">
  <sub-header header="'Deposit check to account'"></sub-header>

    <!-- Product information -->
    <deposit-product-information account-details="\$ctrl.depositAccount" ></deposit-product-information>

    <!-- Operation form -->
    <form name="\$ctrl.transactionForm">

      <check-form
        check-model="\$ctrl.checkModel"
        product-id="\$ctrl.productId"
        entry-type="'CREDIT'">
      </check-form>

      <div class="buttons">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-success"
                ng-click="\$ctrl.deposit()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Deposit
        </button>
      </div>
    </form>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/check-deposit/check-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;